"use client";

import React, { useState, useEffect } from "react";
import { blogPosts } from "./BlogPost";
import "./Blog.css"; // Make sure this is the same CSS file from your first version

const categories = ["ALL", ...new Set(blogPosts.map((post) => post.category))];

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [filteredPosts, setFilteredPosts] = useState(blogPosts);

  useEffect(() => {
    if (selectedCategory === "ALL") {
      setFilteredPosts(blogPosts);
    } else {
      setFilteredPosts(
        blogPosts.filter((post) => post.category === selectedCategory)
      );
    }
  }, [selectedCategory]);

  return (
    <div className="blog-container">
      {/* Category Tabs */}
      <div className="blog-categories">
        {categories.map((category) => (
          <button
            key={category}
            className={`category-button ${
              selectedCategory === category ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category === "ALL"
              ? "All"
              : category.charAt(0) +
                category.slice(1).toLowerCase().replace("_", " ")}
          </button>
        ))}
      </div>

      {/* Blog Grid */}
      <div className="blog-grid">
        {filteredPosts.map((post) => (
          <a
            key={post.id}
            href={`/blog/${post.slug}`}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-card"
          >
            <div className="blog-card-image-container">
              <img
                src={post.image || "/placeholder.svg"}
                alt={post.title}
                className="blog-card-image"
              />
              <div className="blog-card-badge">Your Salon</div>
            </div>
            <div className="blog-card-content">
              <div className="blog-card-meta">
                <span className="blog-card-date">
                  {post.date} / {post.author}
                </span>
              </div>
              <div className="blog-card-category">| {post.category}</div>
              <h3 className="blog-card-title">{post.title}</h3>
              <p className="blog-card-excerpt">{post.excerpt}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blog;
